module.exports = __webpack_public_path__ + "static/shargaas-symbol-DND3_FnP-0fa60c323a1515678dea12f439bca52d.webp";